/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CloseAction from './CloseAction/index'
import CoreEmbeddableSection from 'DesignSystem/CoreEmbeddableSection/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/ToothChart/Content/Preview/Content/Edit/Content"
  
}) {
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let toothChartValueData = fromData.useDataValue({ viewPath,
context: 'tooth_chart',
})
let globalRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'refresh_embedded_section',
})
let globalSessionExpiredRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'session_expired_refresh_embedded_section',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="90%"
 height="90%"
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h2"
 text="Tooth chart"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<CoreEmbeddableSection
  viewPath={`${viewPath}/CoreEmbeddableSection`}
 section_type="patients"
 data="global.current_location._id"
 location_id={globalCurrentLocationIdValueData}
 data="tooth_chart"
 params={toothChartValueData}
 data="global.refresh_embedded_section"
 refresh={globalRefreshEmbeddedSectionValueData}
 data="global.session_expired_refresh_embedded_section"
 session_expired_refresh={globalSessionExpiredRefreshEmbeddedSectionValueData}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}